import React, { useState } from 'react';
import { UserIcon, PencilRulerIcon, CalendarIcon, EyeIcon, EditIcon, DownloadIcon, ShareIcon, RulerIcon, PieChartIcon, DropletIcon, TagIcon, ChevronRightIcon, ChevronLeftIcon, ListIcon, LayoutGridIcon, FoldersIcon } from 'lucide-react';
import { FolderView } from './FolderView';
// Mock data for my designs
const myDesignsData = [{
  id: 'MD001',
  name: 'Western Field Pivot System',
  description: 'Main field irrigation system',
  date: 'Aug 05, 2025',
  status: 'active',
  model: 'Pivot CP600',
  pivotCount: 1,
  specs: {
    length: '300.00 m',
    angle: '360°',
    area: '35.00 ha',
    flow: '38.50 l/s',
    pressure: '2.20 bar'
  },
  lastModified: '2025-08-05',
  tags: ['Standard', 'Full-Circle']
}, {
  id: 'MD002',
  name: 'Eastern Linear System',
  description: 'Linear system for rectangular field',
  date: 'Jul 28, 2025',
  status: 'completed',
  model: 'Linear',
  pivotCount: 1,
  specs: {
    length: '350.00 m',
    angle: 'N/A',
    area: '40.00 ha',
    flow: '45.00 l/s',
    pressure: '2.50 bar'
  },
  lastModified: '2025-07-28',
  tags: ['Linear', 'High-Flow']
}, {
  id: 'MD003',
  name: 'South Field Corner System',
  description: 'Corner arm addition to existing pivot',
  date: 'Jul 15, 2025',
  status: 'pending',
  model: 'Corner Arm',
  pivotCount: 1,
  specs: {
    length: '70.00 m',
    angle: 'N/A',
    area: '+8.00 ha',
    flow: '+18.00 l/s',
    pressure: '2.30 bar'
  },
  lastModified: '2025-07-15',
  tags: ['Corner', 'Upgrade']
}];
export function MyDesigns({
  searchQuery,
  selectedDealer,
  selectedRegion,
  selectedModel
}) {
  const [viewType, setViewType] = useState('grid'); // 'grid', 'list', or 'folders'
  // Filter designs based on search query and model
  const filteredDesigns = myDesignsData.filter(design => {
    const matchesSearch = searchQuery === '' || design.id.toLowerCase().includes(searchQuery.toLowerCase()) || design.name.toLowerCase().includes(searchQuery.toLowerCase()) || design.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesModel = selectedModel === 'all' || design.model.toLowerCase().includes(selectedModel.toLowerCase());
    return matchesSearch && matchesModel;
  });
  const handleViewDesign = design => {
    console.log('Viewing design:', design);
    // Aquí implementarías la lógica para ver un diseño
  };
  return <div data-id="element-2891">
      {/* Dashboard summary */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-6 border-b border-gray-200 bg-gray-50" data-id="element-2892">
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2893">
          <div className="flex justify-between items-start" data-id="element-2894">
            <div data-id="element-2895">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2896">
                My Designs
              </h3>
              <p className="text-4xl font-bold text-blue-600" data-id="element-2897">
                {filteredDesigns.length}
              </p>
            </div>
            <div className="bg-blue-100 p-2 rounded-lg" data-id="element-2898">
              <PencilRulerIcon size={24} className="text-blue-600" data-id="element-2899" />
            </div>
          </div>
          <div className="mt-4 text-sm text-gray-600" data-id="element-2900">
            Last updated: {new Date().toLocaleDateString()}
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2901">
          <div className="flex justify-between items-start" data-id="element-2902">
            <div data-id="element-2903">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2904">Status</h3>
              <div className="mt-2" data-id="element-2905">
                <div className="flex justify-between text-sm mb-1" data-id="element-2906">
                  <span data-id="element-2907">Active</span>
                  <span className="font-medium" data-id="element-2908">
                    {filteredDesigns.filter(d => d.status === 'active').length}
                  </span>
                </div>
                <div className="flex justify-between text-sm mb-1" data-id="element-2909">
                  <span data-id="element-2910">Completed</span>
                  <span className="font-medium" data-id="element-2911">
                    {filteredDesigns.filter(d => d.status === 'completed').length}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-2912">
                  <span data-id="element-2913">Pending</span>
                  <span className="font-medium" data-id="element-2914">
                    {filteredDesigns.filter(d => d.status === 'pending').length}
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-green-100 p-2 rounded-lg" data-id="element-2915">
              <UserIcon size={24} className="text-green-600" data-id="element-2916" />
            </div>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2917">
          <div className="flex justify-between items-start" data-id="element-2918">
            <div data-id="element-2919">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2920">Models</h3>
              <div className="mt-2" data-id="element-2921">
                <div className="flex justify-between text-sm mb-1" data-id="element-2922">
                  <span data-id="element-2923">Pivot CP600</span>
                  <span className="font-medium" data-id="element-2924">
                    {filteredDesigns.filter(d => d.model === 'Pivot CP600').length}
                  </span>
                </div>
                <div className="flex justify-between text-sm mb-1" data-id="element-2925">
                  <span data-id="element-2926">Linear</span>
                  <span className="font-medium" data-id="element-2927">
                    {filteredDesigns.filter(d => d.model === 'Linear').length}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-2928">
                  <span data-id="element-2929">Corner Arm</span>
                  <span className="font-medium" data-id="element-2930">
                    {filteredDesigns.filter(d => d.model === 'Corner Arm').length}
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-indigo-100 p-2 rounded-lg" data-id="element-2931">
              <RulerIcon size={24} className="text-indigo-600" data-id="element-2932" />
            </div>
          </div>
        </div>
      </div>

      {/* View type toggle */}
      <div className="flex justify-between items-center px-6 py-3 bg-white border-b border-gray-200" data-id="element-2933">
        <div className="text-gray-700 font-medium" data-id="element-2934">
          {filteredDesigns.length} designs
        </div>
        <div className="flex border border-gray-200 rounded-lg overflow-hidden" data-id="element-2935">
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'list' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('list')} data-id="element-2936">
            <ListIcon size={16} className="mr-1" data-id="element-2937" />
            List
          </button>
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'grid' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('grid')} data-id="element-2938">
            <LayoutGridIcon size={16} className="mr-1" data-id="element-2939" />
            Grid
          </button>
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'folders' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('folders')} data-id="element-2940">
            <FoldersIcon size={16} className="mr-1" data-id="element-2941" />
            Folders
          </button>
        </div>
      </div>

      {/* Designs view (grid, list, or folders) */}
      {viewType === 'folders' ? <div className="h-[calc(100vh-400px)] min-h-[400px]" data-id="element-2942">
          <FolderView designs={filteredDesigns} onViewDesign={handleViewDesign} data-id="element-2943" />
        </div> : viewType === 'grid' ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6" data-id="element-2944">
          {filteredDesigns.map(design => <DesignCard key={design.id} design={design} data-id="element-2945" />)}
          {filteredDesigns.length === 0 && <div className="col-span-3 text-center py-12 text-gray-500" data-id="element-2946">
              No designs found matching your search criteria
            </div>}
        </div> : <div className="overflow-x-auto" data-id="element-2947">
          <table className="w-full" data-id="element-2948">
            <thead className="bg-gray-50" data-id="element-2949">
              <tr data-id="element-2950">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2951">
                  ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2952">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2953">
                  Model
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2954">
                  Specs
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2955">
                  Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2956">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2957">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-2958">
              {filteredDesigns.map(design => <tr key={design.id} className="hover:bg-gray-50" data-id="element-2959">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2960">
                    {design.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2961">
                    <div className="font-medium" data-id="element-2962">{design.name}</div>
                    <div className="text-gray-500 text-xs" data-id="element-2963">
                      {design.description}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2964">
                    <div className="flex items-center" data-id="element-2965">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ddVxmMM9BG37mQQDtAXhse/8120_pierce.svg" alt="Pivot Machine" className="h-8 mr-2" data-id="element-2966" />
                      <div data-id="element-2967">
                        {design.model}
                        <div className="text-xs text-gray-500" data-id="element-2968">
                          {design.pivotCount}{' '}
                          {design.pivotCount === 1 ? 'unit' : 'units'}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2969">
                    <div className="flex gap-2 text-xs" data-id="element-2970">
                      <span className="bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full" data-id="element-2971">
                        {design.specs.length}
                      </span>
                      <span className="bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-full" data-id="element-2972">
                        {design.specs.area}
                      </span>
                      <span className="bg-teal-50 text-teal-700 px-2 py-0.5 rounded-full" data-id="element-2973">
                        {design.specs.flow}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2974">
                    {design.date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2975">
                    <StatusBadge status={design.status} data-id="element-2976" />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2977">
                    <div className="flex space-x-2" data-id="element-2978">
                      <button className="text-blue-600 hover:text-blue-800" data-id="element-2979">
                        <EyeIcon size={16} data-id="element-2980" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-800" data-id="element-2981">
                        <EditIcon size={16} data-id="element-2982" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-800" data-id="element-2983">
                        <ShareIcon size={16} data-id="element-2984" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
          {filteredDesigns.length === 0 && <div className="text-center py-12 text-gray-500" data-id="element-2985">
              No designs found matching your search criteria
            </div>}
        </div>}
    </div>;
}
// Helper component for design cards
function DesignCard({
  design
}) {
  const getStatusColor = status => {
    switch (status) {
      case 'active':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      case 'completed':
        return 'bg-green-100 text-green-700 border-green-200';
      case 'pending':
        return 'bg-amber-100 text-amber-700 border-amber-200';
      default:
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }
  };
  return <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2986">
      <div className="p-5 border-b border-gray-100" data-id="element-2987">
        <div className="flex justify-between items-start" data-id="element-2988">
          <div data-id="element-2989">
            <div className="flex items-center" data-id="element-2990">
              <h3 className="font-bold text-gray-900 truncate max-w-[200px]" data-id="element-2991">
                {design.name}
              </h3>
              <span className="ml-2 bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full" data-id="element-2992">
                {design.id}
              </span>
            </div>
            <p className="text-gray-600 text-sm mt-1" data-id="element-2993">{design.description}</p>
          </div>
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(design.status)}`} data-id="element-2994">
            {design.status.charAt(0).toUpperCase() + design.status.slice(1)}
          </span>
        </div>
      </div>
      <div className="px-5 py-4 flex justify-between items-center bg-gray-50 border-b border-gray-100" data-id="element-2995">
        <div className="flex items-center" data-id="element-2996">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ddVxmMM9BG37mQQDtAXhse/8120_pierce.svg" alt="Pivot Machine" className="h-12 mr-3" data-id="element-2997" />
          <div data-id="element-2998">
            <div className="text-sm font-medium text-gray-900" data-id="element-2999">
              {design.model}
            </div>
            <div className="text-xs text-gray-500" data-id="element-3000">
              {design.pivotCount} {design.pivotCount === 1 ? 'unit' : 'units'}
            </div>
          </div>
        </div>
        <div className="text-right" data-id="element-3001">
          <div className="text-xs text-gray-500 flex items-center justify-end" data-id="element-3002">
            <CalendarIcon size={12} className="mr-1" data-id="element-3003" />
            {design.date}
          </div>
        </div>
      </div>
      <div className="px-5 py-4" data-id="element-3004">
        <h4 className="text-xs font-medium text-gray-500 mb-2" data-id="element-3005">
          SPECIFICATIONS
        </h4>
        <div className="grid grid-cols-3 gap-2" data-id="element-3006">
          <div className="bg-blue-50 rounded-lg p-2 text-center" data-id="element-3007">
            <div className="text-xs text-blue-600 mb-1 flex items-center justify-center" data-id="element-3008">
              <RulerIcon size={12} className="mr-1" data-id="element-3009" />
              Length
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-3010">
              {design.specs.length}
            </div>
          </div>
          <div className="bg-indigo-50 rounded-lg p-2 text-center" data-id="element-3011">
            <div className="text-xs text-indigo-600 mb-1 flex items-center justify-center" data-id="element-3012">
              <PieChartIcon size={12} className="mr-1" data-id="element-3013" />
              Area
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-3014">
              {design.specs.area}
            </div>
          </div>
          <div className="bg-teal-50 rounded-lg p-2 text-center" data-id="element-3015">
            <div className="text-xs text-teal-600 mb-1 flex items-center justify-center" data-id="element-3016">
              <DropletIcon size={12} className="mr-1" data-id="element-3017" />
              Flow
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-3018">
              {design.specs.flow}
            </div>
          </div>
        </div>
        <div className="mt-3 flex flex-wrap gap-1" data-id="element-3019">
          {design.tags.map((tag, index) => <span key={index} className="bg-gray-100 text-gray-700 text-xs px-2 py-0.5 rounded-full flex items-center" data-id="element-3020">
              <TagIcon size={10} className="mr-1" data-id="element-3021" />
              {tag}
            </span>)}
        </div>
      </div>
      <div className="px-5 py-3 border-t border-gray-100 flex justify-between" data-id="element-3022">
        <div className="flex space-x-2" data-id="element-3023">
          <button className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center" data-id="element-3024">
            <EyeIcon size={14} className="mr-1" data-id="element-3025" />
            View
          </button>
          <button className="text-gray-600 hover:text-gray-800 text-sm font-medium flex items-center" data-id="element-3026">
            <EditIcon size={14} className="mr-1" data-id="element-3027" />
            Edit
          </button>
        </div>
        <div className="flex space-x-2" data-id="element-3028">
          <button className="text-gray-600 hover:text-gray-800" data-id="element-3029">
            <ShareIcon size={16} data-id="element-3030" />
          </button>
          <button className="text-gray-600 hover:text-gray-800" data-id="element-3031">
            <DownloadIcon size={16} data-id="element-3032" />
          </button>
        </div>
      </div>
    </div>;
}
// Helper component for status badges
function StatusBadge({
  status
}) {
  let config = {
    color: 'gray',
    text: 'Unknown'
  };
  switch (status) {
    case 'active':
      config = {
        color: 'blue',
        text: 'Active'
      };
      break;
    case 'completed':
      config = {
        color: 'green',
        text: 'Completed'
      };
      break;
    case 'pending':
      config = {
        color: 'amber',
        text: 'Pending'
      };
      break;
  }
  const colors = {
    blue: 'bg-blue-100 text-blue-800',
    green: 'bg-green-100 text-green-800',
    amber: 'bg-amber-100 text-amber-800',
    gray: 'bg-gray-100 text-gray-800'
  };
  return <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${colors[config.color]}`} data-id="element-3033">
      {config.text}
    </span>;
}